import { Component, OnInit, OnChanges, Input, HostListener, ElementRef, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ContextsContextsService } from 'src/app/services/contexts-services/contexts-contexts-services/contexts-contexts.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { SecurityService } from 'src/app/services/security-service/security.service';
import { EMPTY, empty } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-contexts-context-info-card',
  templateUrl: './contexts-context-info-card.component.html',
  styleUrls: ['./contexts-context-info-card.component.scss']
})
export class ContextsContextInfoCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() context;
  centerList;
  editingLocked: boolean;
  refreshContextListenSubscription: Subscription;
  updateContextSubscription: Subscription;
  basicDataForm = new FormGroup({
    name: new FormControl({ value: null, disabled: true }, Validators.required),
    active: new FormControl({ value: false, disabled: true }),
    selectedCenter: new FormControl({ value: null, disabled: true }, Validators.required),
    context: new FormControl({ value: null, disabled: true }, Validators.required),
    oauth: new FormControl({ value: null, disabled: true }, Validators.required)
  });

  constructor(private contextsService: ContextsContextsService,
    private userStorageService: UserStorageService,
    private securityService: SecurityService,
    private snackbarService: SnackBarService,
    private eRef: ElementRef) {
      this.editingLocked = true;
    }

  ngOnInit() {
    this.centerList = this.userStorageService.getCenterList();
    this.refreshContextListenSubscription = this.contextsService.refreshContextListen().pipe(
      tap(o => this.resetForm())
    ).subscribe();
  }

  ngOnChanges() {
    if (this.context) {
      this.resetForm();
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
    } else {
      if (event.path[0].className !== 'mat-option-text') {
        if (this.context && !this.editingLocked) {
          this.resetForm();
          this.lockEdition();
        }
      }
    }
  }

  public randomContext() {
    this.basicDataForm.patchValue({
      token: this.securityService.genRandomToken()
    });
  }

  public submitForm() {
    this.updateContextSubscription = this.contextsService.updateContextInfo( this.context.InternalId, this.basicDataForm.get('active').value, this.basicDataForm.get('name').value, this.getSelectedCenter(), this.basicDataForm.get('context').value).pipe(
      tap(o => this.lockEdition()),
      tap(o => this.contextsService.refreshContext()),
      tap(o => this.snackbarService.open('contexts-page.snackbar messages.update apisecret success', 'success')),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public toggleEdition() {
    if (this.editingLocked) {
      this.unlockEdition();
    } else {
      const validation = this.validateForm();
      if (validation === true) {
        this.submitForm();
      } else {
        this.snackbarService.open(validation, 'error');
      }
    }
  }

  public validateForm() {
    if (!this.basicDataForm.get('name').valid) {
      return 'contexts-page.snackbar messages.name apisecret error';
    } else if (!this.basicDataForm.get('selectedCenter').value) {
      return 'contexts-page.snackbar messages.selected center apisecret error';
    } else {
      return true;
    }
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      name: this.context.SessionName,
      active: this.context.Active,
      selectedCenter: this.setSelectedCenter(),
      context: this.context.ApiSecret,
      oauth: this.context.ApiAccessToken,
    });
  }

  public unlockEdition() {
    this.basicDataForm.get('name').enable();
    this.basicDataForm.get('active').enable();
    this.basicDataForm.get('selectedCenter').enable();
    this.editingLocked = false;
  }

  public lockEdition() {
    this.basicDataForm.get('name').disable();
    this.basicDataForm.get('active').disable();
    this.basicDataForm.get('selectedCenter').disable();
    this.editingLocked = true;
  }

  public setSelectedCenter() {
    if (this.context && this.centerList && this.centerList.length > 0) {
      for (const center of this.centerList) {
        if (center.InternalId === this.context.CenterInternalId) {
          return center;
        }
      }
    } else {
      return null;
    }
  }

  public getSelectedCenter() {
    if (this.centerList && this.centerList.length > 0) {
      if (this.basicDataForm.get('selectedCenter').value) {
        return this.basicDataForm.get('selectedCenter').value.InternalId;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }

  ngOnDestroy() {
    if (this.refreshContextListenSubscription) { this.refreshContextListenSubscription.unsubscribe(); }
    if (this.updateContextSubscription) { this.updateContextSubscription.unsubscribe(); }
  }
}
